import React from "react";
import styled, { css } from "styled-components";
var IconArrowSvg = function IconArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.406 8.784.246 4.258a.675.675 0 0 1 0-1.042.926.926 0 0 1 1.189 0L6 7.22l4.565-4.005a.926.926 0 0 1 1.189 0 .675.675 0 0 1 0 1.042l-5.16 4.526A.9.9 0 0 1 6 9a.901.901 0 0 1-.594-.216Z"
  }));
};
IconArrowSvg.defaultProps = {
  width: "16",
  height: "9",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import getBorderColor from "../../../utils/getBorderColor";
import getIconColor from "../../../utils/getIconColor";
import space, { spaceFactor } from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import AnimateHeightOrg from "../../organisms/AnimateHeightOrg";
var gutterVerticalSpace = 4;
var iconSizeSpace = 1.5;
export var Header = styled.div.withConfig({
  componentId: "sc-kdueue-0"
})(function (_ref) {
  var $hasHiddenArrow = _ref.$hasHiddenArrow;
  return css(["display:flex;align-items:center;justify-content:space-between;padding:", " 0;cursor:pointer;", ""], space(gutterVerticalSpace), $hasHiddenArrow && css(["cursor:default;"]));
});
export var Wrapper = styled.div.withConfig({
  componentId: "sc-kdueue-1"
})(function (_ref2) {
  var $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["border-bottom:", " solid ", ";&:first-child{", "{padding-top:0;}}"], unit(1), getBorderColor(theme, $onColor, "low"), Header);
});
export var ContentWrapper = styled(AnimateHeightOrg).withConfig({
  componentId: "sc-kdueue-2"
})(["> *:last-child{padding-bottom:", ";}"], space(gutterVerticalSpace));
export var IconArrow = styled(IconArrowSvg).withConfig({
  componentId: "sc-kdueue-3"
})(function (_ref3) {
  var $titleTypography = _ref3.$titleTypography,
    $onColor = _ref3.$onColor,
    theme = _ref3.theme;
  return css(["", ";flex-shrink:0;margin-top:", ";fill:", ";"], transition("fill", "transform"), unit((theme.typography[$titleTypography].lineHeightSpace - iconSizeSpace) * spaceFactor / 2), getIconColor(theme, $onColor, "high"));
});